import * as AuthenticateAPI from '../actions/ApiCalls';

const login = async (payload) => {
   return await AuthenticateAPI.postResponse(`/auth/login`, payload);
};

const register = async (payload) => {
   return await AuthenticateAPI.postResponse(`/auth/register`, payload);
};

const forgotPassword = async (payload) => {
   return await AuthenticateAPI.postResponse(
      `/auth/forget-password/token`,
      payload,
   );
};

const verify = async (payload) => {
   return await AuthenticateAPI.postResponse('/auth/token/verify', payload)
}

const setPassword = async (payload) => {
   return await AuthenticateAPI.postResponse(`/auth/forget-password`, {
      ...payload,
      token: Number(payload.token),
   });
};

const setNewPassword = async (payload) => {
   return await AuthenticateAPI.postResponse(`/auth/new-password`, payload);
};
const profile = async (payload) => {
   return await AuthenticateAPI.getResponse(`/auth/profile`, payload);
};
const UpdateProfile = async (payload) => {
   return await AuthenticateAPI.updateCall(`/auth/profile`, payload);
};
const ResetToken = async (payload) => {
   return await AuthenticateAPI.postRefreshToken(
      `/auth/refresh-token`,
      payload,
   );
};
const getCount = async () => {
   return await AuthenticateAPI.getResponse(`/shared/counts`);
};

const feedback = async (payload) => {
   return await AuthenticateAPI.postResponse(`/feedback`, payload);
};

const authService = {
   login,
   register,
   forgotPassword,
   setPassword,
   profile,
   ResetToken,
   getCount,
   feedback,
   UpdateProfile,
   verify,
   setNewPassword,
};

export default authService;
